import MenuItem from '@mui/material/MenuItem';
import { DeleteButton } from 'framework/ui/ui-builder';
import { useListContext } from 'framework/list';

type DeleteTimelineRecordButtonProps = {
  permissionToCheck: Nullable<string | string[]>;
  deleteMethod: (id: string) => Promise<void>;
  entityName: string;
  id: string;
  timelineId: string;
  buttonText?: string;
};

const DeleteTimelineRecordButton = ({
  permissionToCheck,
  deleteMethod,
  entityName,
  timelineId,
  id,
  buttonText = 'Delete',
}: DeleteTimelineRecordButtonProps) => {
  const message = `Do you really want to delete this ${entityName}?`;
  const { deleteFromList } = useListContext();

  return (
    <DeleteButton
      deleteMethod={() => deleteMethod(id)}
      afterDelete={{
        execute: () => (deleteFromList ? deleteFromList(timelineId) : null),
      }}
      displayMessage={message}
      permissionToCheck={permissionToCheck}
      showIcon={false}
      buttonTag={MenuItem}
      className="danger-color"
      buttonText={buttonText}
    />
  );
};

export default DeleteTimelineRecordButton;
